import * as React from "react";
import { navTo } from "@origin-digital/event-dispatcher";
import {
  Stack,
  Heading,
  Button,
  Text,
  MarkdownLite,
  Columns,
  Column,
} from "@origin-digital/ods-core";
import content from "../../cms/chat.json";
import { AsyncMessenger } from "./AsyncMessenger";

interface IChatProps {
  isNative: boolean;
  nativeChatSupported: boolean | undefined;
}

// Desktop
const LiveChatSection = (): JSX.Element => {
  const { contactUs } = content;
  return (
    <>
      <Stack alignX={["left", "center"]}>
        <Button
          data-id="contact-us-button"
          onClick={() => {
            navTo.contactUs();
          }}
        >
          {contactUs.button}
        </Button>
      </Stack>
    </>
  );
};

// Native
const PhoneAndEmailSection = (): JSX.Element => {
  // Do not destructure `content.phoneOrEmail` properties will be undefined. This might be a wp5 bug.
  // For some reason, if `content.phoneOrEmail` used WP minification rename props of content.phoneOrEmail.
  const { phoneOrEmail } = content;
  return (
    <Columns
      alignX={["left", "center"]}
      collapseBelow="lg"
      data-id="chat-item-other"
    >
      <Column width="2/3">
        <Stack alignX={["left", "center"]}>
          <Text align={["left", "center"]} data-id={"contact"}>
            <MarkdownLite data-testid="contact">{`${phoneOrEmail.phone}${phoneOrEmail.email}`}</MarkdownLite>
          </Text>
        </Stack>
      </Column>
    </Columns>
  );
};

export const Chat = (chatProps: IChatProps): JSX.Element => {
  const { nativeChatSupported, isNative } = chatProps;
  const { heading } = content;
  return (
    <>
      {nativeChatSupported && <AsyncMessenger />}
      <Columns
        alignX={["left", "center"]}
        collapseBelow="lg"
        space={["none", "xxxlarge"]}
        data-id="chat"
      >
        <Column width="2/3">
          <Stack alignX={["left", "center"]} space={["medium", "medium"]}>
            <Heading variant="h3">{heading}</Heading>
            <Stack space={["xlarge", "xxlarge"]}>
              {!isNative && <LiveChatSection />}
              {isNative && <PhoneAndEmailSection />}
            </Stack>
          </Stack>
        </Column>
      </Columns>
    </>
  );
};
